import Slider from "react-slick";

function Pro(){
    const settings = {
        arrows: true,
        dots: true,
        mobileFirst: true,
        swipeToSlide: true,
        touchMove: true,
        cssEase: "ease-out",
        adaptiveHeight: true,
    }

    return(
        <Slider {...settings}>
            <article>
                <h3 className="mt-2em">Assistant Administratif</h3>
                <p className="text-blue">Mars 2024 – Janvier 2026</p>
                <p>Montpellier Dépannage, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Stage Développement Web</h3>
                <p className="text-blue">Juin 2023 – Août 2023</p>
                <p>ASAP Studio, Montpellier</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Utilisation de JavaScript Vanilla et PHP, sur des projets WordPress</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Mise en place de composants pour un projet interne en Nuxt/Vue.js</p>
            </article>
            <article>
                <h3 className="mt-2em">Formateur Junior à distance</h3>
                <p className="text-blue">Octobre 2020 – Juin 2021</p>
                <p>Formateur junior en langues et en bureautique.</p>
                <p>ATE Formation, Montpellier</p>
                <div className="flex">
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Français Langue Étrangère (FLE)</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Anglais</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Espagnol</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Pack Office</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Microsoft 365</p>
                </div>
            </article>
            <article>
                <h3 className="mt-2em">Employé polyvalent de restauration</h3>
                <p className="text-blue">Avril 2019 - Septembre 2020</p>
                <p>La Cave du 164, Hôtel Ibis Montpellier Sud, Montpellier</p>
                <div>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Serveur</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Barman</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Sommelier</p>
                    <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Cuisinier</p>
                </div>
            </article>
            <article>
                <h3 className="mt-2em">Conseiller de vente</h3>
                <p className="text-blue">Janvier - Juillet 2018</p>
                <p>Drôle de Pain, boulangerie artisanale, Montpellier</p>
            </article>
            <article>
                <h3 className="mt-2em">Employé polyvalent de restauration</h3>
                <p className="text-blue">Juin - Septembre 2017</p>
                <p>Hôtel Novotel Près d'arènes, Montpellier</p>
                <p>Serveur, groom service, accueil de salon, bar…</p>
            </article>
            <article>
                <h3 className="mt-2em">Employé polyvalent de restauration</h3>
                <p className="text-blue">Juillet - Octobre 2016</p>
                <p>Hôtel Novotel Près d'arènes, Montpellier</p>
                <p>Serveur, groom service, accueil de salon, bar…</p>
            </article>
        </Slider>
    )
}

export default Pro
